import React from 'react';
import PropTypes from 'prop-types';

import links from '../../../config/links';
import styles from './form.scss';
import Img from '../Img';

const PopupV2 = (props) => {
    return (
        <div className={styles.popup}>
            <div className={styles.popupBox}>
                <div
                    onClick={(ev) => {
                        props.closePopup(ev, props.popUpType);
                    }}
                    className={styles.popupClose}
                    data-testid="modal.additional-info.close-btn"
                >
                    <Img src="/img/v4/close-icon.svg" />
                </div>
                <div className={styles.popupContent}>
                    {(props.popUpType === PopupTypes.BIRTHDAY) && (
                        <>
                            <div className="mt8">
                                <Img src="/img/v4/info-icon.svg" align="left" />
                                <div className="text-medium fs15 ml32" data-testid="modal.additional-info.heading">
                                    Why do we require birthday?
                                </div>
                            </div>
                            <div className="ml12">
                                <ul>
                                    <li className={`${styles.popupText} mt8`}>
                                        Providing your birthday ensures the best tennis experience in the app for your age.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        Your privacy is important so we don’t display your birthdate or age publicly
                                        without your explicit permission. For more details, please visit our <a href={links.dataPolicy} target="_blank" rel="noopener noreferrer" data-testid="modal.additional-info.data-policy-link">Data Policy</a>.
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                    {(props.popUpType === PopupTypes.BIRTHDAY_CLUB) && (
                        <>
                            <div className="mt8">
                                <Img src="/img/v4/info-icon.svg" align="left" />
                                <div className="text-medium fs15 ml32" data-testid="modal.additional-info.heading">
                                    Why do we require birthday?
                                </div>
                            </div>
                            <div className="ml12">
                                <ul>
                                    <li className={`${styles.popupText} mt8`}>
                                        We need to ensure that you are of appropriate age to run UTR Sports events and access the web site.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        Your privacy is important so we don’t display your birthdate or age publicly on
                                        the website without your explicit permission. For more details, please visit our <a href={links.dataPolicy} target="_blank" rel="noopener noreferrer" data-testid="modal.additional-info.data-policy-link">Data Policy</a>.
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                    {(props.popUpType === PopupTypes.PARENTS) && (
                        <>
                            <div className="mt8">
                                <Img src="/img/v4/info-icon.svg" align="left" />
                                <div className="text-medium fs15 ml32" data-testid="modal.additional-info.heading">
                                    If you are a parent creating an account on behalf of a child
                                </div>
                            </div>
                            <div className="ml12">
                                <ul>
                                    <li className={`${styles.popupText} mt8`}>
                                        Please fill out the player details as your child. This is very important as the information provided is used for event registrations.
                                    </li>
                                    <ul>
                                        <li className={`${styles.popupText} mt4`}>
                                            Note: Date of birth will only be editable upon request once an account is created
                                        </li>
                                    </ul>
                                    <li className={`${styles.popupText} mt4`}>
                                        If you need to create an account for more than one child, you must create separate accounts for each.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        If you have any questions, contact our <a href={links.support} target="_blank" rel="noopener noreferrer" data-testid="modal.additional-info.support-link">support team</a>.
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                    {(props.popUpType === PopupTypes.PLAYER_DETAILS) && (
                        <>
                            <div className="mt8">
                                <Img src="/img/v4/info-icon.svg" align="left" />
                                <div className="text-medium fs15 ml32" data-testid="modal.additional-info.heading">
                                    If you are creating an account on behalf of your child:
                                </div>
                            </div>
                            <div className="ml12">
                                <ul>
                                    <li className={`${styles.popupText} mt8`}>
                                        Complete all player details using the player&apos;s information. Incorrect information may result in registration issues.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        Have more than one child? Create a separate account for each. Player&apos;s cannot share accounts.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        Ensure the DOB of the player is accurate before continuing. DOB cannot be altered once you continue.
                                    </li>
                                    <p className={`${styles.popupText}`}>
                                        <a href={links.supportHome} target="_blank" rel="noopener noreferrer" className="ul" data-testid="modal.additional-info.support-link">Contact Support</a> if you have questions
                                    </p>
                                </ul>
                            </div>
                        </>
                    )}
                    {(props.popUpType === PopupTypes.DATE_OF_BIRTH) && (
                        <>
                            <div className="mt8">
                                <Img src="/img/v4/info-icon.svg" align="left" />
                                <div className="text-medium fs15 ml32" data-testid="modal.additional-info.heading">
                                    Why do we require Date of Birth for all players?
                                </div>
                            </div>
                            <div className="ml12">
                                <ul>
                                    <li className={`${styles.popupText} mt8`}>
                                        Date of Birth is used to ensure your account is accurate.
                                    </li>
                                    <li className={`${styles.popupText} mt4`}>
                                        Date of Birth accuracy is essential for age related registrations.
                                    </li>
                                    <p className={`${styles.popupText} text-danger text-bold`}>
                                        Date of Birth cannot be altered once you continue.
                                    </p>
                                </ul>
                            </div>
                            <div className={`${styles.popupText} ml32`}>
                                Note: Your privacy is important to us. Read about our <a href={links.dataPolicy} target="_blank" rel="noopener noreferrer" className="ul" data-testid="modal.additional-info.data-policy-link">Data Policy</a> for more details
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PopupV2;

PopupV2.propTypes = {
    popUpType: PropTypes.string.isRequired,
    closePopup: PropTypes.func.isRequired,
};

export const PopupTypes = {
    BIRTHDAY: 'birthday',
    BIRTHDAY_CLUB: 'birthday_club',
    PARENTS: 'parents',
    DATE_OF_BIRTH: 'date_of_birth',
    PLAYER_DETAILS: 'player_details',
};
